import { FC } from 'react';
import styles from './index.module.scss';
import { DrillDownText } from '../DrillDownText';

/**
 * 配列要素の型定義
 * @param id マスタのidではなくsearchJobTypeIdを格納
 * @param title マスタのnameではなくsearchJobTypeNameを格納
 * @param jobCount
 * @param isBold 太文字判定フラグ
 * @param size 文字サイズ
 * @param url 遷移先URL
 */
export interface ListType {
  id: string;
  title: string;
  jobCount: string;
  isBold: boolean;
  size: 'm' | 's';
  url?: string | null;
}

/**
 * 職種ドリルダウンの型定義
 * @param id マスタのidではなくsearchJobTypeIdを格納
 * @param title マスタのnameではなくsearchJobTypeNameを格納
 * @param jobCount
 * @param url
 * @param list ドリルダウン
 */
export interface OccupationDrillDownType {
  id: string;
  title: string;
  jobCount: string;
  url?: string | null;
  list: ListType[];
}

/**
 * Propsの型定義
 * @param drillDown 職種ドリルダウン
 */
interface Props {
  drillDown: OccupationDrillDownType;
}

export const OccupationDrillDown: FC<Props> = ({ drillDown }) => {
  const { title, jobCount, url, list } = drillDown;

  return (
    <div className={styles.occupationDrillDown}>
      <DrillDownText
        title={title}
        jobCount={jobCount}
        url={url}
        isBold
        size="L"
      />
      <ul className={styles.occupationDrillDown__list}>
        {list.map((item) => {
          return (
            <li
              className={styles.occupationDrillDown__list__item}
              key={item.id}
            >
              <DrillDownText
                title={item.title}
                jobCount={item.jobCount}
                url={item.url}
                isBold={item.isBold}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
